import { Typography } from '@mui/material';
import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux'
const { useState, useEffect, useRef } = React;
//import estilos from './FormularioFC30BeneficiarioComponent.module.css';



const INSPECTORES = [
    { nombre: 'I.Q JOSE CARLOS FLORES ZARATE', credencial: 'C-169.22', telefono: '238 130 1031' },
    { nombre: 'BIOL. ROGELIO REYES SILVA', credencial: 'C-174.23', telefono: '443 105 1031' },
    { nombre: 'ING. GUILLERMO DONATLAN SIMENTAL', credencial: 'C-175.23', telefono: '618 117 5085' },
    { nombre: 'ING. HUGO BAUTISTA GARCIA', credencial: 'C-120.18', telefono: '951 175 5257' },
    { nombre: 'ING. RAFAEL VALDIVIA GARCES', credencial: 'C-123.18', telefono: '951 113 7260' },
    { nombre: 'ING. ROMAN G. MANCERA PACHECO/ I.Q JORGE ALEJANDRO VALENCIA MONTERO', credencial: 'C-230.25', telefono: '951 239 5191' },
    { nombre: 'I.Q EDWIN JARED KAT MARTINEZ', credencial: 'C-168.22', telefono: '971 222 2969' },
    { nombre: 'H. SAMMY HERNANDEZ PEREZ/ ING. HUGO BAUTISTA GARCIA', credencial: 'C-240.26', telefono: '951 580 0220' },
    { nombre: 'I.I CARLOS GUADALUPE RODRIGUEZ CAMACHO', credencial: 'C-204.23', telefono: '951 197 1038' },
    { nombre: 'I.I ALEXIS MARQUEZ MARTINEZ/ I.Q JORGE ALEJANDRO VALENCIA MONTERO', credencial: 'C-239.26', telefono: '951 271 2382' },
    { nombre: 'I.Q JORGE ALEJANDRO VALENCIA MONTERO', credencial: 'C-141.21', telefono: '951 343 5555' },
    { nombre: 'I.Q JOSE M. MONTENEGRO CERVANTES/ ING. HUGO BAUTISTA GARCIA', credencial: 'C-238.26', telefono: '951 234 9964' },
    { nombre: 'I.Q LUCIO MANUEL OLIVERA GARCIA', credencial: 'C-207.23', telefono: '951 283 3386' },
    { nombre: 'ING. UZIEL CRUZ BORJAS', credencial: 'C-108.16', telefono: '951 231 0883' },
];

const FormularioDocumentacionFC_35 = (props) => {
    const solicitud = useSelector(store => store.FC_35SolicitudAtencionACliente.data)

    //DATOS PARA GENERAR DOCUMENTACIÓN DE CONTRATOS
    const [numeroSolicitud, setNumeroSolicitud] = useState('');
    const [numCertificadoNOM, setNumCertificadoNOM] = useState('');
    const [numeroTraslado, setNumeroTraslado] = useState('');
    const [otrosServicios, setOtrosServicios] = useState('');
    const [fechaInspeccion, setFechaInspeccion] = useState('');
    const [numeroPlanEvaluacion, setNumeroPlanEvaluacion] = useState('');
    const [inspectorAsignado, setInspectorAsignado] = useState('');
    const [credencialInspector, setCredencialInspector] = useState('');
    const [telefonoInspector, setTelefonoInspector] = useState('');
    const handleInspectorChange = (nombreInspector) => {
        setInspectorAsignado(nombreInspector);
        const inspector = INSPECTORES.find(i => i.nombre === nombreInspector);
        if (inspector) {
            setCredencialInspector(inspector.credencial);
            setTelefonoInspector(inspector.telefono);
        } else {
            setCredencialInspector('');
            setTelefonoInspector('');
        }
    }


    const botonAceptar = () => {
        const data = {
            numeroSolicitud, numCertificadoNOM, numeroTraslado, otrosServicios, fechaInspeccion, numeroPlanEvaluacion,
            inspectorAsignado, credencialInspector, telefonoInspector,
        }
        props.functionAcept(data)
    }
    return (
        <Fragment>
            <h6 className='text-center'>SOLICITUD DE SERVICIOS DE INSPECCIÓN</h6>
            <div className='row justify-content-start mb-2 text-center'>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="floatingInput" className={`form-control`}
                            onChange={e => setNumeroSolicitud(e.target.value)}
                            value={numeroSolicitud}
                            placeholder='No. de solicitud' />
                        <label className="floatingInput">No. de solicitud</label>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="floatingInput" className={`form-control`}
                            onChange={e => setNumCertificadoNOM(e.target.value)}
                            value={numCertificadoNOM}
                            placeholder='No. Certificado NOM vigente' />
                        <label className="floatingInput">No. Certificado NOM vigente</label>
                    </div>
                </div>
                {/*<div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                        <div className="form-floating mb-3">
                            <input type="text" id="floatingInput" className={`form-control`}
                                onChange={e => setNumeroTraslado(e.target.value)}
                                value={numeroTraslado}
                                placeholder='Número de traslado' />
                            <label className="floatingInput">Número de traslado</label>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                        <div className="form-floating mb-3">
                            <input type="text" id="floatingInput" className={`form-control`}
                                onChange={e => setOtrosServicios(e.target.value)}
                                value={otrosServicios}
                                placeholder='Otros servicios' />
                            <label className="floatingInput">Otros servicios</label>
                        </div>
            </div>*/}
            </div>
            <hr />
            <h6 className='text-center'>PLAN DE EVALUACIÓN</h6>
            <div className='row justify-content-start mb-2 text-center'>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="floatingInput" className={`form-control`}
                            onChange={e => setNumeroPlanEvaluacion(e.target.value)}
                            value={numeroPlanEvaluacion}
                            placeholder='No. Plan de evaluación' />
                        <label className="floatingInput">No. del plan de evaluación</label>
                    </div>

                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <select className="form-select" id="floatingSelect"
                            onChange={e => handleInspectorChange(e.target.value)}
                            value={inspectorAsignado}>
                            <option value="">Seleccione un inspector...</option>
                            {INSPECTORES.map((insp, index) => (
                                <option key={index} value={insp.nombre}>{insp.nombre}</option>
                            ))}
                        </select>
                        <label htmlFor="floatingSelect">Inspector asignado</label>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="floatingInput" className={`form-control`}
                            onChange={e => setCredencialInspector(e.target.value)}
                            value={credencialInspector}
                            placeholder='Credencial del inspector' />
                        <label className="floatingInput">Credencial del inspector</label>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="floatingInput" className={`form-control`}
                            onChange={e => setTelefonoInspector(e.target.value)}
                            value={telefonoInspector}
                            placeholder='Teléfono del inspector' />
                        <label className="floatingInput">Teléfono del inspector</label>
                    </div>
                </div>
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }} className='text-center'>
                Está a punto de aceptar la solicitud, ya no podrá seguir revisándola
                y los datos se tomarán como válidos.<br /> <strong>¿Desea continuar?</strong>
            </Typography>
            <div className='row'>
                <button className='btn btn-success' onClick={() => botonAceptar()}
                    disabled={solicitud.otrosservicios ? (numeroSolicitud == '' || numeroPlanEvaluacion == '' ||
                        inspectorAsignado == '' || credencialInspector == '' || telefonoInspector == '') ? true : false : false}
                >CONTINUAR</button>
            </div>
        </Fragment>
    );
};

export default FormularioDocumentacionFC_35;
